module.exports = __webpack_public_path__ + "img/Character_Rosaria_Thumb.81326f61.png";